function isValidDate(date) {
  // eslint-disable-next-line no-restricted-globals
  return date instanceof Date && !isNaN(date)
}

export const getFormattedDate = dateString => {
  const date = new Date(dateString)

  if (!isValidDate(date)) {
    return ''
  }

  const month = date.toLocaleString('default', { month: 'long' })

  return `${date.getDate()} ${month} ${date.getFullYear()}`
}
